// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26U5g","content":"styles_content__3EdFY"};